module.exports = __webpack_public_path__ + "img/775176e.svg";